import { Box, Heading, SimpleGrid, VStack, Text, Icon } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { IconType } from "react-icons";
import { FaTint, FaLeaf, FaFeather } from "react-icons/fa";

const MotionBox = motion(Box);

export default function Features() {
  const ChakraIcon = (icon: IconType) => icon as unknown as React.ElementType;

  const features = [
    {
      icon: FaTint,
      title: "Hidratação Profunda",
      desc: "Nossa combinação de emolientes naturais garante uma hidratação duradoura, prevenindo o ressecamento e deixando a pele incrivelmente macia.",
    },
    {
      icon: FaLeaf,
      title: "Regeneração da Pele",
      desc: "Vitaminas e antioxidantes estimulam a renovação celular, reparando danos e devolvendo o brilho natural aos seus pés.",
    },
    {
      icon: FaFeather,
      title: "Macia como Pluma",
      desc: "Textura aveludada a cada aplicação. Reduza áreas ásperas e desfrute de pés irresistivelmente suaves.",
    },
  ];

  return (
    <MotionBox
      py={20}
      px={{ base: 6, md: 24 }}
      bg="sedapeLight"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <Heading textAlign="center" mb={12} color="sedapePinkDark">
        Sinta a Diferença Sedapé
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
        {features.map((f, i) => (
          <VStack
            key={i}
            p={8}
            bg="white"
            borderRadius="xl"
            boxShadow="md"
            spacing={4}
            transition="transform 0.3s"
            _hover={{ transform: "translateY(-5px)" }}
          >
            <Icon as={ChakraIcon(f.icon)} boxSize={10} color="sedapeGoldDark" />
            <Heading fontSize="xl" color="sedapePinkDark">
              {f.title}
            </Heading>
            <Text color="gray.700">{f.desc}</Text>
          </VStack>
        ))}
      </SimpleGrid>
    </MotionBox>
  );
}
